<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from "axios";
import Swal from "sweetalert2";
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "chapter-add",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      v$: useVuelidate(),
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      title: "",
      description: "",
      formSending: false,
    };
  },
  components: {
    Breadcrumb,
    InputText,
  },
  validations() {
    return {
      title: { required },
    };
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope
          ? `/courses/${this.courseId}/chapters`
          : `/chapter/${this.gradeSlug}`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [
          ...base,
          { name: 'الأبواب', path: this.basePath },
          { name: 'أضافه باب', path: `${this.basePath}/add` },
        ];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: 'الأبواب', path: this.basePath },
        { name: 'أضافه باب', path: `${this.basePath}/add` },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() {
      return this.resolvedGrade?.id ?? null;
    },
  },
  methods: {
    sendForm() {
      this.v$.$validate();
      if (!this.v$.$error) {
        const formData = new FormData();
        formData.append('title', this.title);
        formData.append('description', this.description);
        if (this.isCourseScope) {
          formData.append('course_id', this.courseId);
        } else {
          formData.append('academic_year_id', this.gradeId);
        }
        formData.append('type', 2);
        this.formSending = true;

        axios
            .post('/lessons', formData)
            .then(() => {
              this.formSending = false;
              this.resetForm();
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الاضافه بنجاح",
              });
            })
            .catch((error) => {
              this.formSending = false;
              Swal.fire({
                position: "center",
                icon: "error",
                title: error.response.data.message,
              });
            });
      }
    },
    resetForm() {
      this.v$.$reset();
      this.title = "";
      this.description = "";
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="form-page">
    <div class="form-page-header">
      <div class="form-page-header__icon">
        <i class="pi pi-sitemap"></i>
      </div>
      <div class="form-page-header__text">
        <h1 class="form-page-header__title">إضافة باب</h1>
        <p class="form-page-header__subtitle">إضافة باب جديد للمنهج الدراسي</p>
      </div>
    </div>

    <div class="container-fluid">
      <form @submit.prevent="sendForm()">
        <div class="form-card">
          <div class="form-card__header">
            <div class="form-card__header-icon"><i class="pi pi-pencil"></i></div>
            <span class="form-card__title">تفاصيل الباب</span>
          </div>
          <div class="form-card__body">
            <div class="row g-4">
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="title">
                    اسم الباب <span class="required">*</span>
                  </label>
                  <InputText id="title" v-model="title" placeholder="أدخل اسم الباب" class="w-100" />
                  <span class="field-error" v-if="v$.title.$error">
                    <i class="pi pi-exclamation-circle"></i> برجاء ادخال اسم الباب
                  </span>
                </div>
              </div>
              <div class="col-lg-6 col-12">
                <div class="form-field">
                  <label class="field-label" for="description">
                    وصف الباب <span class="optional">اختياري</span>
                  </label>
                  <InputText id="description" v-model="description" placeholder="أدخل وصف الباب" class="w-100" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button type="submit" class="btn-submit" :disabled="formSending">
            <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
            <i class="pi pi-check" v-else></i>
            {{ formSending ? 'جاري الإرسال...' : 'حفظ الباب' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
